<mad-main-container class="w-full">
  <mad-content-header>
    @if (headerContentPortal) {
      <ng-template [cdkPortalOutlet]="headerContentPortal"></ng-template>
    } @else {
      <div class="sidebar-wrapper default-header-wrapper">
        <div class="back-and-title">
          @if (hasBackButton) {
            <button class="back-button">
              <mat-icon (click)="goToPreviousPage()" class="mat-primary"> arrow_back</mat-icon>
            </button>
          }
          @if (titleTemplate) {
            <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
          } @else {
            <h2 class="title">{{ title }}</h2>
          }
        </div>
        <ng-template [cdkPortalOutlet]="actionGroupPortal"></ng-template>
      </div>
    }
  </mad-content-header>
  <mad-content-panel-container>
    @if (sideBarItemsPortal) {
      <mad-content-panel-container-sidebar>
        <ng-template [cdkPortalOutlet]="sideBarItemsPortal"></ng-template>
      </mad-content-panel-container-sidebar>
    }
    @if (contentPortal) {
      <mad-content-panel-container-content>
        <ng-template [cdkPortalOutlet]="contentPortal"></ng-template>
      </mad-content-panel-container-content>
    }
    @if (footerPortal) {
      <mad-content-panel-container-footer>
        <ng-template [cdkPortalOutlet]="footerPortal"></ng-template>
      </mad-content-panel-container-footer>
    }
  </mad-content-panel-container>
</mad-main-container>
